export default __webpack_public_path__ + "static/media/MedicalTonic.3fb67304c2a44c43cc076abb27a32c4a.webp";